import { ChevronLeft, ChevronRight } from "lucide-react";

type ScrollArrowProps = {
  direction: "previous" | "next";
  label: string;
  /** At the end of the row. aria-disabled (not disabled) so keyboard focus is never dropped mid-press. */
  inactive: boolean;
  onPress: () => void;
  /** "md" is a 44px target for the carousel; "sm" a compact 36px one for the chip row. */
  size?: "sm" | "md";
  className?: string;
};

/** Round previous/next button shared by the agent carousel and the category chip row. */
export function ScrollArrow({
  direction,
  label,
  inactive,
  onPress,
  size = "md",
  className = "",
}: ScrollArrowProps) {
  const Icon = direction === "previous" ? ChevronLeft : ChevronRight;
  return (
    <button
      type="button"
      aria-label={label}
      aria-disabled={inactive}
      onClick={() => {
        if (!inactive) onPress();
      }}
      className={`inline-flex shrink-0 items-center justify-center rounded-full border border-border bg-card text-foreground shadow-sm transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary ${
        size === "md" ? "h-11 w-11" : "h-9 w-9"
      } ${
        inactive
          ? "cursor-default opacity-40"
          : "hover:border-primary/40 hover:text-primary active:scale-95 motion-reduce:active:scale-100"
      } ${className}`}
    >
      <Icon className={size === "md" ? "h-5 w-5" : "h-4 w-4"} aria-hidden />
    </button>
  );
}
